const firebaseConfig = {
    apiKey: "AIzaSyD16urQ3_7SBK138YxxQftspp1QUbRrQIA",
    authDomain: "blog-world-96fa6.firebaseapp.com",
    projectId: "blog-world-96fa6",
    storageBucket: "blog-world-96fa6.appspot.com",
    messagingSenderId: "221900313665",
    appId: "1:221900313665:web:3556d88e27c371cd05e2c0"
  };
  export default firebaseConfig